<div class="page-title-area">
  <div class="container-custom">
    <div class="page-title-content">
      <ul>
        <li><a routerLink="/centros-medicos-listado">Listado de Centros Médicos</a></li>
      </ul>
      <h2>Modificar Centro Médico</h2>
      <h4 *ngIf="signoCentroMedico">{{ signoCentroMedico.nombre }}</h4>

      <!-- Informe Resumen Rápido (Petición Usuario) -->
      <div class="summary-report animate__animated animate__fadeIn" *ngIf="signoCentroMedico">
        <div class="summary-item">
          <div class="icon-box spec"><i class="fas fa-stethoscope"></i></div>
          <div class="info-box">
            <span class="count">{{ especialidadesSeleccionadas?.length || 0 }}</span>
            <span class="label">Especialidades</span>
          </div>
        </div>
        <div class="summary-item">
          <div class="icon-box rubro"><i class="fas fa-tag"></i></div>
          <div class="info-box">
            <span class="count">{{ rubrosSeleccionados?.length || 0 }}</span>
            <span class="label">Rubros</span>
          </div>
        </div>
        <div class="summary-item">
          <div class="icon-box plan"><i class="fas fa-file-invoice-dollar"></i></div>
          <div class="info-box">
            <span class="count">{{ form?.get('planes')?.value?.length || 0 }}</span>
            <span class="label">Planes</span>
          </div>
        </div>
        <div class="summary-item">
          <div class="icon-box phone"><i class="fas fa-phone-alt"></i></div>
          <div class="info-box">
            <span class="count">{{ (telefonosList?.length || 0) + (celularesList?.length || 0) }}</span>
            <span class="label">Contactos</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="form-wrapper padding-70 animate__animated animate__fadeIn">
  <div class="container-custom">
    <div class="form-row justify-content-center">
      <div class="form-col-12">
        <div class="apply-form">
          <form [formGroup]="form" (ngSubmit)="updateCentroMedico()">

            <!-- 1. Nombre y Activo -->
            <div class="form-row">
              <div class="form-col-8">
                <div class="form-group">
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Centro Médico</mat-label>
                    <input formControlName="nombre" matInput placeholder="Centro Médico"
                      [class.is-invalid]="centroMedicoNoValido" autocomplete="off">
                    <mat-error *ngIf="centroMedicoNoValido">Ingrese un centro médico</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="form-col-4">
                <div class="form-group">
                  <mat-slide-toggle formControlName="activo">Activo</mat-slide-toggle>
                </div>
              </div>
            </div>

            <!-- 2. Sección Dirección y Ubicación -->
            <!-- <div class="section-title">
              <h3>Dirección y Ubicación</h3>
            </div> -->
            <div class="form-row map-address-section">
              <div class="form-col-6">
                <!-- Calle -->
                <div class="form-group">
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Calle</mat-label>
                    <input type="text" matInput
                           [formControl]="calleControl"
                           [matAutocomplete]="autoCalle"
                           (input)="onCalleInput()"
                           placeholder="Ej: Av. Corrientes o 4 de Abril"
                           [class.is-invalid]="calleNoValida"
                           autocomplete="off">
                    <mat-autocomplete #autoCalle="matAutocomplete"
                                      (optionSelected)="onCalleSelected($event)"
                                      [displayWith]="displayCalleFn">
                      <mat-option *ngFor="let suggestion of calleSuggestions" [value]="suggestion">
                        {{ suggestion.place_name }}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="calleNoValida">Ingrese una calle válida</mat-error>
                  </mat-form-field>
                </div>

                <!-- Altura + Botón Buscar -->
                <div class="direccion-inline-row">
                  <mat-form-field appearance="fill" class="altura-field">
                    <mat-label>Altura</mat-label>
                    <input formControlName="altura" matInput placeholder="Número"
                           [class.is-invalid]="alturaNoValida" autocomplete="off"
                           (keyup.enter)="buscarDireccionCompleta()">
                    <mat-error *ngIf="alturaNoValida">Ingrese una altura</mat-error>
                  </mat-form-field>
                  <button mat-raised-button type="button" class="btn-search-map"
                          (click)="buscarDireccionCompleta()"
                          [disabled]="!form.get('calle')?.value || !form.get('altura')?.value">
                    <mat-icon>search</mat-icon> Buscar
                  </button>
                </div>

                <!-- Zona y Localidad -->
                <div class="form-row">
                  <div class="form-col-6">
                    <mat-form-field appearance="fill" class="full-width">
                      <mat-label>Zona</mat-label>
                      <mat-select formControlName="zona" required
                                  [class.is-invalid]="zonaNoValida">
                        <mat-option *ngFor="let zona of zonas" [value]="zona._id!">
                          {{ zona.concepto }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="zonaNoValida">Seleccione una zona</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="form-col-6">
                    <mat-form-field appearance="fill" class="full-width">
                      <mat-label>Localidad</mat-label>
                      <mat-select formControlName="localidad" required
                                  [class.is-invalid]="localidadNoValida">
                        <mat-option *ngFor="let localidad of localidades" [value]="localidad._id!">
                          {{ localidad.nombre }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="localidadNoValida">Seleccione una localidad</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <!-- Piso/Depto y Horarios -->
                <div class="form-row">
                  <div class="form-col-6">
                    <mat-form-field appearance="fill" class="full-width">
                      <mat-label>Piso/Depto/Casa</mat-label>
                      <input formControlName="pisoDpto" matInput placeholder="Piso o Depto o Casa" autocomplete="off">
                    </mat-form-field>
                  </div>
                  <div class="form-col-6">
                    <mat-form-field appearance="fill" class="full-width">
                      <mat-label>Horarios</mat-label>
                      <input formControlName="horarios" type="text" matInput
                             placeholder="Lunes a Viernes de 10hrs a 18hrs" autocomplete="off">
                      <mat-icon matSuffix>access_time</mat-icon>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <!-- Mapa -->
              <div class="form-col-6 map-col">
                <app-map></app-map>
              </div>
            </div>

            <!-- 3. Teléfonos y Celulares -->
            <div class="form-row">
              <div class="form-col-12">
                <div class="form-group">
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Ingresar Teléfono o Celular (WhatsApp)</mat-label>
                    <input type="text" matInput placeholder="Ej: 11 1234-5678" [(ngModel)]="inputTelefonoCelular"
                      [ngModelOptions]="{ standalone: true }" autocomplete="off">
                    <mat-icon matSuffix>phone</mat-icon>
                  </mat-form-field>
                  <div class="button-group">
                    <button type="button" (click)="agregarTelefonoCelular('telefono')" class="mat-button-add-telefono">Agregar Teléfono</button>
                    <button type="button" (click)="agregarTelefonoCelular('celular')" class="mat-button-add-celular">Celular (WhatsApp)</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Listas de contactos agregados -->
            <div class="form-row contact-lists-section">
              <div class="form-col-6" *ngIf="telefonosList.length > 0">
                <div class="contact-list-container">
                  <h3>Teléfonos Agregados:</h3>
                  <ul class="contact-items-list">
                    <li *ngFor="let telefono of telefonosList; let i = index" class="contact-item">
                      <span class="item-text">{{ telefono }}</span>
                      <button class="delete-btn" (click)="eliminarTelefono(i)">✕</button>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="form-col-6" *ngIf="celularesList.length > 0">
                <div class="contact-list-container">
                  <h3>Celulares Agregados:</h3>
                  <ul class="contact-items-list">
                    <li *ngFor="let celular of celularesList; let i = index" class="contact-item">
                      <span class="item-text">{{ celular }}</span>
                      <button class="delete-btn" (click)="eliminarCelular(i)">✕</button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- 4. Especialidades, Rubros y Planes (grid de 3, alineados) -->
            <div class="form-row align-top">
              <!-- Especialidades con chips + autocomplete -->
              <div class="form-col-4">
                <div class="form-group chip-autocomplete-group">
                  <mat-label class="chip-list-label">Especialidades</mat-label>
                  <mat-chip-list #chipListEspecialidades aria-label="Selección de especialidades" class="chip-list-container">
                    <mat-chip
                      *ngFor="let especialidad of especialidadesSeleccionadas"
                      (removed)="removeEspecialidad(especialidad._id!)">
                      {{ especialidad.concepto }}
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <input
                      placeholder="Buscar especialidad..."
                      #especialidadInput
                      [formControl]="especialidadControl"
                      [matAutocomplete]="autoEspecialidad"
                      [matChipInputFor]="chipListEspecialidades"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      (matChipInputTokenEnd)="addEspecialidad($event)"
                      class="chip-input" />
                  </mat-chip-list>
                  <mat-autocomplete 
                    #autoEspecialidad="matAutocomplete" 
                    (optionSelected)="selectedEspecialidad($event)"
                    panelClass="autocomplete-wide">
                    <mat-option *ngFor="let especialidad of filteredEspecialidades" [value]="especialidad._id!">
                      {{ especialidad.concepto }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-hint>(Puede seleccionar más de una o ninguna)</mat-hint>
                </div>
              </div>

              <!-- Rubros con chips + autocomplete -->
              <div class="form-col-4">
                <div class="form-group chip-autocomplete-group">
                  <mat-label class="chip-list-label">Rubros</mat-label>
                  <mat-chip-list #chipListRubros aria-label="Selección de rubros" class="chip-list-container">
                    <mat-chip
                      *ngFor="let rubro of rubrosSeleccionados"
                      (removed)="removeRubro(rubro._id!)">
                      {{ rubro.concepto }}
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <input
                      placeholder="Buscar rubro..."
                      #rubroInput
                      [formControl]="rubroControl"
                      [matAutocomplete]="autoRubro"
                      [matChipInputFor]="chipListRubros"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      (matChipInputTokenEnd)="addRubro($event)"
                      class="chip-input" />
                  </mat-chip-list>
                  <mat-autocomplete 
                    #autoRubro="matAutocomplete" 
                    (optionSelected)="selectedRubro($event)"
                    panelClass="autocomplete-wide">
                    <mat-option *ngFor="let rubro of filteredRubros" [value]="rubro._id!">
                      {{ rubro.concepto }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-hint>(Puede seleccionar más de uno o ninguno)</mat-hint>
                </div>
              </div>

              <!-- Planes (mat-select múltiple) -->
              <div class="form-col-4">
                <div class="form-group">
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Planes</mat-label>
                    <mat-select formControlName="planes" multiple>
                      <mat-option *ngFor="let plan of planes" [value]="plan._id!">
                        {{ plan.denominacion }}
                      </mat-option>
                    </mat-select>
                    <mat-hint>(Puede seleccionar más de uno o ninguno, no es requerido)</mat-hint>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <!-- Coordenadas (ocultas) -->
            <div class="form-row" hidden>
              <div class="form-col-6">
                <div class="form-group">
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Latitud</mat-label>
                    <input formControlName="latitud" matInput placeholder="Latitud" autocomplete="off"
                      (change)="updatesCoordinates()" (input)="updateMarkerLocation()">
                    <mat-error *ngIf="form.get('latitud')?.hasError('pattern')">Ingrese una latitud válida.</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="form-col-6">
                <div class="form-group">
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Longitud</mat-label>
                    <input formControlName="longitud" matInput placeholder="Longitud" autocomplete="off"
                      (change)="updatesCoordinates()" (input)="updateMarkerLocation()">
                    <mat-error *ngIf="form.get('longitud')?.hasError('pattern')">Ingrese una longitud válida.</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <!-- Botones de acción -->
            <div class="form-actions">
              <button mat-stroked-button class="btn-cancel" type="button" routerLink="/centros-medicos-listado">
                Cancelar
              </button>
              <button mat-raised-button class="btn-save" [disabled]="!form.valid" type="submit">
                Guardar
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>